"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const isPathApi_1 = __importDefault(require("../legacy-editor-package/utils/isPathApi"));
const isFilter_1 = __importDefault(require("./isFilter"));
const isPathAction_1 = __importDefault(require("./isPathAction"));
function isPathNode(node) {
    return (node &&
        isPathApi_1.default(node.selected_api) &&
        isFilter_1.default(node.type_of) &&
        isPathAction_1.default(node.action));
}
exports.default = isPathNode;
